// extracted by mini-css-extract-plugin
export default {"green":"pga_green__WmduC","box":"pga_box__VNsIW","pgalogo":"pga_pgalogo__y5uOE","grid":"pga_grid__eZlc1","statsGrid":"pga_statsGrid__kVmGs","twitter":"pga_twitter__10eHc"};